import React from 'react';
import './ProgramNewPage.css';
import Container from '../components/Container';
import '../styles/generics.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageComponent from '../components/PageComponent';
import Labels from '../Labels';
import Connection from '../config/Connection';
import { Modal, Button, InputGroup, Form, Dropdown, DropdownButton, FormControl } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Parsers from '../Tools/Parsers';
import GenericHelper from '../Tools/GenericHelper';
import CompanyPage from './CompanyPage';
import MaskedInput from '../components/MaskedInput';
import AdminPage from './AdminPage';
import ErrorComponent from '../components/ErrorComponent';


const creationType = [
  "CNPJ"
];


export default class ProgramNewPage extends PageComponent {
  static PageInfo = {

    path: "/Program/New",
    parent: AdminPage,
    name: "menu.newprogram",
    access: { 1: true },
    permission: { "PROGRAM_CREATION": true },
    icon: "trophy"
  }

  loaded = { brands: null, types: null, payment: null, billing: null, period: null, qatype: null };

  constructor(props) {
    super(props);
    this.data = props.match.params;
    this.state.data = null;
    this.state.loading = true;
    this.state.modalInitializing = false;
    this.state.modalError = null;
    this.state.modalLoading = false;
    this.state.costumerLoading = false;
    this.state.isModalVisible = null;
    this.state.form = {
      brand: null,
      hierarchy: null,
      fkClientType: null,
      label: null,
    };
    this.state.promotionalBudgetTypeId = null;
  }

  componentDidMount() {
    Connection.Secure(Connection.service + 'Brand/List')
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            this.doneLoading("brands", data);
          });
        else this.setState({ error: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error, loading: false });
      });

    Connection.Secure(Connection.service + 'Customer/Types')
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            this.doneLoading("types", data);
          });
        else this.setState({ error: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error, loading: false });
      });

    Connection.Secure(Connection.service + 'ProgramPaymentType')
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            this.doneLoading("payment", data);
          });
        else this.setState({ error: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error, loading: false });
      });

    Connection.Secure(Connection.service + 'ProgramBillingType')
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            this.doneLoading("billing", data);
          });
        else this.setState({ error: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error, loading: false });
      });

    Connection.Secure(Connection.service + 'ProgramPeriodType')
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            this.doneLoading("period", data);
          });
        else this.setState({ error: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error, loading: false });
      });

    Connection.Secure(Connection.service + 'QualitativeAwardType')
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            this.doneLoading("qatype", data);
          });
        else this.setState({ error: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error, loading: false });
      });
  }

  doneLoading(target, value) {
    this.loaded[target] = value;

    for (var i in this.loaded)
      if (this.loaded[i] == null) return;

    this.loaded.loading = false;
    setTimeout(() => this.setState(this.loaded));
  }

  updateForm(target, value) {
    this.state.form[target] = value;
    this.setState({ form: this.state.form });
  }

  checkForm(target, ignoreList) {
    for (var i in target)
      if (target[i] == null) {
        var valid = false;
        for (let j = 0; j < ignoreList.length && !valid; j++)
          if (ignoreList[j] == i) valid = true;
        if (!valid)
          return false; 
      }
    return true;
  }

  addNew() {
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service +
      "Program",
      {
        "method": "POST",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.state.form)
      })
      .then((response) => {
        if (response.ok && response.status == 200)
          response.text().then((d) => {

            var l = ("/Program/Detail/" + d);
            this.setState({ modalLoading: false, isModalVisible: null },
              () => this.props.history.push(l));
          })
        else this.setState({ modalLoading: false, isModalVisible: null });
      })
      .catch((error) => {
        this.setState({ modalLoading: false, isModalVisible: null });
      });
  }
  changeDropdown(target) {
    this.setState({ selectionType: target, filter: "" });
  }

  openModal() {
    this.setState({
      isModalVisible: "select", modalInitializing: true,
      modalLoading: false,
      modalError: null,
      data: null, region: null, city: null, filter: "", selectionType: "name"
    });
    Connection.Secure(Connection.service + 'State/List/')
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            setTimeout(() => this.setState({ states: data }, this.setState({ modalInitializing: false })));
          });
        this.setState({ modalError: response, modalInitializing: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalInitializing: false });
      });
  }

  render() {
    return (
      <Container context={this.constructor}>

        <div className="generics_panels" style={{ display: "block" }}>
          {
            this.state.error != null ? <ErrorComponent error={this.state.error} /> :
              this.state.loading ? <div>{Labels.GetLabel("generic.loading")}</div> :
                <div>
                  <div className="generics_panels_header"><FontAwesomeIcon icon={this.constructor.PageInfo.icon} /> <span> {Labels.GetLabel(this.constructor.PageInfo.name)}</span></div>
                  <div>
                    <div style={{ padding: 20 }}>
                      <div className="generic_section_header">{Labels.GetLabel('program.programinfo')}</div>
                      <MaskedInput type="text" notnull={true} label={Labels.GetLabel("generic.name")} onValid={(value) => this.updateForm("label", value)}
                        onInvalid={(value) => this.updateForm("label", null)} />
                      <MaskedInput type="select" label={Labels.GetLabel("generic.brand")} notnull={true} onValid={(value) => this.updateForm("brand", { keyConstant: parseInt(value[0]) })}
                        onInvalid={(value) => this.updateForm("brand", null)} name="keyConstant,label" data={this.state.brands} placeholder={Labels.GetLabel("generic.select")} />
                      <div style={{ display: "flex" }}>
                        <div style={{ flex: 1 }}>
                          <MaskedInput type="select" label={Labels.GetLabel("generic.clienttype")} onValid={(value) => this.updateForm("fkClientType", value != null ? value[0] : value)}
                            onInvalid={(value) => this.updateForm("fkClientType", null)} name="bunch,label" data={this.state.types} parser={(t, v) => Labels.GetLabel("CLIENT_TYPE." + v, t)} placeholder={Labels.GetLabel("generic.all")} />
                        </div>
                        <div style={{ flex: 1, marginLeft: 10 }}>
                          <MaskedInput type="select" label={Labels.GetLabel("program.hierarchy")} data={[{ bunch: false }, { bunch: true }]} notnull={true} onValid={(value) => this.updateForm("hierarchy", value[0] == "true")}
                            onInvalid={(value) => this.updateForm("hierarchy", null)} parser={t => Labels.GetLabel("program.hierarchy_" + t)} name="bunch,bunch" placeholder={Labels.GetLabel("generic.select")} />
                        </div>
                      </div>
                      <br />
                      <br />
                      <div style={{ textAlign: "right", marginTop: 30 }}>
                        <Button variant="success" size="lg" disabled={!this.checkForm(this.state.form, ["fkClientType"])} onClick={() => this.setState({ isModalVisible: "confirm", modalLoading: false })}>{Labels.GetLabel("generic.confirm")}</Button>
                      </div>
                    </div>
                  </div>
                </div>
          }

          <Modal
            className={this.state.modalLoading == true ? "modal-loading" : ""}
            onHide={() => { }} show={this.state.isModalVisible != null}

          >
            <div>
              {
                this.state.modalInitializing == true ?
                  <div>
                    {Labels.GetLabel("adminstategroup.saving")}
                  </div>
                  :
                  <div>
                    <Modal.Header>
                      <Modal.Title>{Labels.GetLabel(this.constructor.PageInfo.name)}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {Labels.GetLabel("clientsnew.confirmation")}
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                        {Labels.GetLabel("adminstategroup.closebtn")}
                      </Button>
                      <Button variant="primary" onClick={() => this.addNew()}>
                        {Labels.GetLabel("adminstategroup.savebtn")}
                      </Button>
                    </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                  </div>
              }
            </div>
          </Modal>
        </div>
      </Container >
    );
  }
} 